import { initPromoteAdmin } from './promote-admin';

async function bootstrap(): Promise<void> {
  const lead = document.getElementById('promote-status-lead');
  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error(`Config unavailable (${response.status}).`);
    }
    const config = (await response.json()) as Parameters<typeof initPromoteAdmin>[0];
    initPromoteAdmin(config);
  } catch (error) {
    if (lead !== null) {
      lead.textContent =
        error instanceof Error ? error.message : 'Promote admin is not configured for this host.';
    }
  }
}

void bootstrap();
